// pages/TruckOwnerManagement/TruckOwnerManagementListConfig.jsx
import React from "react";
import ConfigurableList from "../../components/common/ConfigurableList/ConfigurableList";
import { userServices } from "../../services/AllServices";
import { STATUS_OPTIONS_LIST } from "../../utils/constants";

export default function TruckOwnerManagementListConfig() {
  const config = {
    title: "Truck Owner Management",
    
    // Define table fields
    fields: [
      {
        key: "S.No",
        width: "50px",
        sortable: true,
      },
      {
        key: "name",
        label: "Name",
        sortable: true,
      },
      {
        key: "email",
        label: "Email",
        sortable: true,
      },
      {
        key: "phone",
        label: "Phone Number",
        sortable: true,
      },
    ],

    // Define service functions
    services: {
      fetchData: async (params) => {
        return await userServices.getUser({
          search: params.search || "",
          page: params.page,
          limit: params.limit,
          status: params.status || [],
        });
      },
      deleteData: async (id) => {
        return await userServices.deleteUser({ id });
      },
      blockData: async (id) => {
        return await userServices.blockUser({ id });
      },
      toggleStatus: async (id, isActive) => {
        return await userServices.changeStatus({ id, isActive });
      },
    },

    // Define filters
    filters: [
      {
        key: "status",
        name: "Status",
        options: STATUS_OPTIONS_LIST,
      },
    ],

    // Define options
    options: {
      enableSearch: true,
      enableFilters: true,
      enablePagination: true,
      defaultPageSize: 10,
      pageSizeOptions: [10, 20, 50],
      searchPlaceholder: "Search",
    },

    // Define messages
    messages: {
      emptyMessage: "No Data Found",
      deleteConfirmMessage: "Are you sure you want to delete this user?",
      blockConfirmMessage: (isBlocked) => 
        `Are you sure you want to ${isBlocked ? "unblock this user" : "block this user"}?`,
    },

    // Define layout
    layout: {
      showSerialNumber: true,
      showStatus: true,
      showActions: true,
      basePath: "/truck-owner-management",
      actions: {
        showView: true,
        showEdit: true,
        showBlock: true,
        showDelete: true,
      },
      customActions: [
        // Add any custom actions here if needed
        // {
        //   tooltip: "Custom Action",
        //   icon: <CustomIcon />,
        //   onClick: (row) => console.log("Custom action", row),
        //   sx: { color: "blue" },
        // },
      ],
      headerActions: null, // Can add header actions like "Add New" button
    },
  };

  return <ConfigurableList config={config} />;
}

// Alternative: Export configuration for reuse
// export const truckOwnerListConfig = {
//   title: "Truck Owner Management",
//   fields: [
//     { key: "name", label: "Name", sortable: true },
//     { key: "email", label: "Email", sortable: true },
//     { key: "phone", label: "Phone Number", sortable: true },
//   ],
//   services: {
//     fetchData: (params) => userServices.getUser({
//       search: params.search || "",
//       page: params.page,
//       limit: params.limit,
//       status: params.status || [],
//     }),
//     deleteData: (id) => userServices.deleteUser({ id }),
//     blockData: (id) => userServices.blockUser({ id }),
//     toggleStatus: (id, isActive) => userServices.changeStatus({ id, isActive }),
//   },
//   filters: [
//     { key: "status", name: "Status", options: STATUS_OPTIONS_LIST },
//   ],
//   options: {
//     enableSearch: true,
//     enableFilters: true,
//     enablePagination: true,
//     defaultPageSize: 10,
//     pageSizeOptions: [10, 20, 50],
//     searchPlaceholder: "Search",
//   },
//   messages: {
//     emptyMessage: "No Data Found",
//     deleteConfirmMessage: "Are you sure you want to delete this user?",
//     blockConfirmMessage: (isBlocked) => 
//       `Are you sure you want to ${isBlocked ? "unblock this user" : "block this user"}?`,
//   },
//   layout: {
//     showSerialNumber: true,
//     showStatus: true,
//     showActions: true,
//     basePath: "/truck-owner-management",
//     actions: {
//       showView: true,
//       showEdit: true,
//       showBlock: true,
//       showDelete: true,
//     },
//   },
// };

// Usage example for other similar lists:
// import { ConfigurableList } from "../../components/common/ConfigurableList/ConfigurableList";
// import { driverListConfig } from "./driverListConfig";
// 
// export default function DriverManagementList() {
//   return <ConfigurableList config={driverListConfig} />;
// }